const TABLE_EVENTS = {
  ROW_CHANGED: "landr-maestro--table-row-changed"
};

export { TABLE_EVENTS };
//# sourceMappingURL=Table.constants.es.js.map
